/**
 * Kundevisning rows: overview-only + presentation + document visibility.
 */

import { applyDocumentVisibility, applyPresentationRules } from "./apply-presentation-rules";
import {
  collectOverviewCalculationIds,
  filterItemsToOfferOverview,
  pageRootCalculations,
} from "./offer-overview-scope";

export function overviewRootCalculationIds(offer) {
  const ids = collectOverviewCalculationIds(offer);
  if (ids.size) return [...ids];
  return pageRootCalculations(offer?.calculations).map((calc) => calc.id);
}

export function prepareCustomerLineItems(
  items,
  {
    offer,
    presentationRules = null,
    alreadyPresented = false,
  } = {}
) {
  const scoped = filterItemsToOfferOverview(items, offer);
  if (alreadyPresented || !presentationRules) {
    return applyDocumentVisibility(scoped, presentationRules || offer?.presentation_rules);
  }
  return applyPresentationRules(scoped, presentationRules, {
    rootCalculationIds: overviewRootCalculationIds(offer),
  });
}
